(function () {
  function initCartRecommendationSwiper() {
    if (typeof Swiper === 'undefined') return;

    document.querySelectorAll('.cart-recommendation-swiper').forEach((swiperElement) => {
      if (swiperElement.classList.contains('swiper-initialized')) return;

      new Swiper(swiperElement, {
        slidesPerView: 'auto',
        spaceBetween: 10,
        speed: 500,

        grabCursor: true,

        freeMode: {
          enabled: true,
          momentum: true,
          sticky: false
        },

        breakpoints: {
          0: {
            spaceBetween: 8
          },
          750: {
            spaceBetween: 10
          }
        }
      });
    });
  }

  /*
   * Initial page load
   */
  document.addEventListener('DOMContentLoaded', initCartRecommendationSwiper);

  /*
   * Shopify theme editor
   */
  document.addEventListener('shopify:section:load', initCartRecommendationSwiper);

  /*
   * Cart drawer is dynamically replaced by Dawn.
   * This observer initializes Swiper again after
   * new cart drawer HTML is added.
   */
  const observer = new MutationObserver(() => {
    initCartRecommendationSwiper();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  /*
   * Fallback after cart updates
   */
  document.addEventListener('cart:updated', () => {
    setTimeout(initCartRecommendationSwiper, 100);
  });
})();